import React from "react";
import {
  Calendar,
  Heart,
  PenLine,
  Settings2,
  Ticket,
  TrendingUp,
  Users,
  Wallet,
} from "lucide-react";
import OperatorBalanceRing from "./OperatorBalanceRing";

const ControlTilePlaceholder = ({ icon: Icon, label, hint }) => (
  <div className="oc-control-tile oc-control-tile-soon">
    <span className="oc-control-icon">
      <Icon size={16} />
    </span>
    <div>
      <em>{label}</em>
      <strong>—</strong>
      {hint ? <p>{hint}</p> : null}
    </div>
  </div>
);

/**
 * Cold-load body: real console copy and structure stay visible.
 * Only DB-backed values show as placeholders until houses/dashboard arrive.
 */
const OperatorConsoleSkeleton = ({ message = "Loading your markets…" }) => (
  <>
    <header className="oc-hero" aria-busy="true">
      <div className="oc-hero-copy">
        <p className="oc-eyebrow">House treasury</p>
        <h1 className="tabular-nums">—</h1>
        <span>Total house balance</span>
      </div>

      <OperatorBalanceRing available={0} locked={0} pending={0} />

      <div className="oc-hero-pools">
        <div>
          <em>Available</em>
          <strong className="tabular-nums">—</strong>
        </div>
        <div>
          <em>Locked</em>
          <strong className="tabular-nums">—</strong>
        </div>
        <div>
          <em>Pending</em>
          <strong className="tabular-nums">—</strong>
        </div>
      </div>

      <div className="oc-hero-secondary">
        <button type="button" className="oc-hero-quick" disabled title={message}>
          <PenLine size={14} />
          Brand
        </button>
        <button type="button" className="oc-hero-quick" disabled title={message}>
          <Calendar size={14} />
          Fixtures
        </button>
        <button type="button" className="oc-hero-quick" disabled title={message}>
          <Settings2 size={14} />
          Limits
        </button>
      </div>
    </header>

    <div className="oc-sync-banner" role="status">
      <span className="oc-skel-spinner" aria-hidden />
      <span>{message}</span>
    </div>

    <div className="oc-stage">
      <section className="oc-panel">
        <header className="oc-panel-head">
          <h2>Your house at a glance</h2>
          <p>Performance, league intel, and how your audience turns into play.</p>
        </header>

        <div className="oc-ab">
          <section className="oc-ab-card oc-ab-hero">
            <div className="oc-ab-hero-main">
              <span className="oc-ab-kicker">House P&amp;L · 7d</span>
              <strong className="oc-ab-hero-value tabular-nums">—</strong>
              <span className="oc-ab-hero-sub">Waiting for house analytics…</span>
            </div>
            <div className="oc-ab-hero-tiles">
              <div className="oc-ab-tile">
                <span>Kept</span>
                <strong className="tabular-nums">—</strong>
              </div>
              <div className="oc-ab-tile">
                <span>Paid out</span>
                <strong className="tabular-nums">—</strong>
              </div>
              <div className="oc-ab-tile">
                <span>New handle</span>
                <strong className="tabular-nums">—</strong>
              </div>
              <div className="oc-ab-tile">
                <span>Tickets in</span>
                <strong className="tabular-nums">—</strong>
              </div>
            </div>
          </section>
        </div>

        <div className="oc-control-grid">
          <ControlTilePlaceholder
            icon={Users}
            label="Bettors"
            hint="Unique customers"
          />
          <ControlTilePlaceholder
            icon={Ticket}
            label="Tickets"
            hint="Open positions"
          />
          <ControlTilePlaceholder
            icon={TrendingUp}
            label="Viewers"
            hint="Profile views"
          />
          <ControlTilePlaceholder
            icon={Heart}
            label="Followers"
            hint="Follow & unfollow events"
          />
          <ControlTilePlaceholder
            icon={Wallet}
            label="Treasury"
            hint="House balance"
          />
        </div>
      </section>
    </div>
  </>
);

export default OperatorConsoleSkeleton;
